export const OPEN_OLD_MMB = 'frontend-shell:openOldMMB';
export const OPEN_CANCELLATIONS = 'frontend-shell:openMMBCancellations';
export const GO_TO_PRODUCT = 'frontend-shell:goToProduct';
export const REFRESH_BY_CHANGE_BOOKING = 'frontend-shell:refreshByChangeBooking';
export const OPEN_BAGS_AND_SEATS_POPUP = 'frontend-shell:openBagsAndSeatsPopup';
export const createMMBHandlers = Odigeo => ({
  goToProduct(params) {
    Odigeo.trigger(GO_TO_PRODUCT, params);
  },
  openMMB(flow) {
    Odigeo.trigger(flow);
  },
  refreshByChangeBooking() {
    Odigeo.trigger(REFRESH_BY_CHANGE_BOOKING);
  },
  openBagsAndSeatsPopup(product) {
    Odigeo.trigger(OPEN_BAGS_AND_SEATS_POPUP, product);
  }
});